import {useEffect, useState} from "react";
import MovieDetails from "./MovieDetails";
import WatchedSummary from "./WatchedSummary";
import WatchedMoviesList from "./WatchedMovieList";
import Loader from "./Loader";
import ErrorMessage from "./ErrorMessage";
import Box from "./Box";
import MovieList from "./MovieList";
import Main from "./Mian";
import NumResults from "./NumResults";
import Search from "./Search";
import NavBar from "./NavBar";
import {useMovies} from "../useMovies";
import {useLocalStorageState} from "../useLocalStorageState";


export default function App() {
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const {movies, isLoading, error, setError} = useMovies(query);
  const [watched, setWatched] = useLocalStorageState([], 'watched');

  function handleSelectMovie(id){
      setSelectedId(selectedId => id === selectedId ? null : id);
  }

  function handleCloseMovie(){
      setSelectedId(null);
  }

  function handleAddWatched(movie){
      setWatched(watched => [...watched, movie]);
  }

  function handleDeleteWatched(movieId){
      setWatched(watched => watched.filter(movie => movie.imdbID !== movieId));
  }

  return (
      <>
        <NavBar>
          <Search query={query} setQuery={setQuery} />
          <NumResults movies={movies} />
        </NavBar>

        <Main>
          <Box>
              {isLoading ? <Loader/> : error ? <ErrorMessage message={error}/> :
                  <MovieList movies={movies} onSelectMovie={handleSelectMovie} />}
          </Box>

          <Box>
              {
                  selectedId ? <MovieDetails selectedId={selectedId}
                                             onCloseMovie={handleCloseMovie}
                                             error={error}
                                             setError={setError}
                                             watchedMovies={watched}
                                             onAddWatched={handleAddWatched}
                      />
                      : (<>
                    <WatchedSummary watched={watched} />
                    <WatchedMoviesList watched={watched} onDeleteWatched={handleDeleteWatched}/>
                    </>)
              }
          </Box>
        </Main>
      </>
  );
}
















